module.exports = __webpack_public_path__ + "img/swipe-dark.0bcff7c2.png";